import { useEffect } from 'react';

// audit AD-10: no admin form warned before a browser refresh/tab-close silently discarded
// in-progress input. Attach this to any form holding real unsaved user input — it only
// registers the native beforeunload prompt while `isDirty` is true, and removes itself the
// moment it isn't (submit, discard, or unmount), so it never fires on a page with nothing to lose.
export default function useUnsavedChangesGuard(isDirty) {
  useEffect(() => {
    if (!isDirty) return undefined;
    const handler = (e) => { e.preventDefault(); e.returnValue = ''; };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [isDirty]);
}
